import { render, staticRenderFns } from "./PsConfigurationEventuals.vue?vue&type=template&id=31f93c5f&scoped=true&"
import script from "./PsConfigurationEventuals.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationEventuals.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationEventuals.vue?vue&type=style&index=0&id=31f93c5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f93c5f",
  null
  
)

export default component.exports